
import ReactDOM from "react-dom/client";
import { useState } from "react";
import { Module1 } from './Module1';
import { Module2 } from './Module2';
import { Module3 } from './Module3';
import "./styles.css";


export default function App() {   

  const [selected, setSelected] = useState(<Module1 />);
  

  return (
    <>
    <div id="column1">
      <div className="fetcher">
        <div className="header">
        <div className="headline">
          <i className="fas fa-cog"></i>Menu
          </div>
          <div className="right"><i className="fa-solid fa-clock"></i>00:00:00</div>
        </div>
        <div className="body">
          <div className="menu"><table><thead></thead><tbody>
          <tr><td onMouseDown={() => setSelected(<Module1 />)}>Module 1</td></tr>
          <tr><td onMouseDown={() => setSelected(<Module2 />)}>Module 2</td></tr>
          <tr><td onMouseDown={() => setSelected(<Module3 />)}>Module 3</td></tr>
          <tr><td onMouseDown={() => setSelected(<Module1 />)}>Module 4</td></tr>
          <tr><td onMouseDown={() => setSelected(<Module2 />)}>Module 5</td></tr>
          <tr><td onMouseDown={() => setSelected(<Module3 />)}>Module 6</td></tr>
          </tbody></table></div>
        </div>
        <div className="footer">
          Status<div className="right">All processes running</div>
        </div>
      </div>
    </div>
    <div id="column2">
    {selected}
    </div>
    </>
  )
  
} 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);











